import React from 'react'
import LeftBar from '../../Components/LeftBar' 
import Dashnav from '../../Components/Dashnav'
import InstructorsComp from './InstructorsComp'

function Instructors() {
  return (
    <div className='mainContainer'>
        <LeftBar/>
        <div className='theMainContainer'>
            <Dashnav/>
            <InstructorsComp/>      
        </div>
    </div>
  )
}

export default Instructors